export const WALLET_V1_POINTS_DAILY_LOGIN = '/v1/wallet/points/daily-login'
export const WALLET_V1_POINTS_DAILY_LOGIN_STATUS = '/v1/wallet/points/daily-login/status'
export const WALLET_V1_POINTS_STREAM = '/v1/wallet/points/stream'
export const WALLET_V1_POINTS_BALANCE = '/v1/wallet/points/balance'
